import { Backdrop, CircularProgress } from "@mui/material";

export function LoadingAnimation(props) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.isOpen}
      data-testid={"loading-animation-backdrop"}
    >
      <CircularProgress aria-label="loading-animation" color="inherit" />
    </Backdrop>
  );
}
